import { formatDistanceToNow } from "date-fns";
import { ptBR, enUS } from "date-fns/locale";

export function calculateTimerPost(createdStr, language) {
  const locales = {
    pt: ptBR,
    en: enUS,
  };

  return formatDistanceToNow(createdStr ? new Date(createdStr) : new Date(), {
    addSuffix: true,
    locale: locales[language] || ptBR,
  });
}